import { lazy } from "react";
import { AuthenticatedHomeRedirect, AuthenticatedRedirect } from "./AuthRedirect";

// Authentication
const Login = lazy(() => import("../pages/Authentication/Login"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));

// Admin pages
const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard"));
const AdminProperties = lazy(() => import("../pages/Admin/Properties"));
const AdminPropertyReview = lazy(() => import("../pages/Admin/PropertyReview"));
const AdminVendors = lazy(() => import("../pages/Admin/Vendors"));
const AdminVendorDetails = lazy(() => import("../pages/Admin/VendorDetails"));
const AdminBookings = lazy(() => import("../pages/Admin/Bookings"));

const authProtectedRoutes = [
  { path: "/dashboard", component: <AdminDashboard /> },
  { path: "/properties", component: <AdminProperties /> },
  { path: "/properties/:id", component: <AdminPropertyReview /> },
  { path: "/vendors", component: <AdminVendors /> },
  { path: "/vendors/:id", component: <AdminVendorDetails /> },
  { path: "/bookings", component: <AdminBookings /> },

  { path: "/index", component: <AuthenticatedHomeRedirect /> },
  { path: "/", exact: true, component: <AuthenticatedHomeRedirect /> },
  { path: "*", component: <AuthenticatedHomeRedirect /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <AuthenticatedRedirect><Login /></AuthenticatedRedirect> },
];

export { authProtectedRoutes, publicRoutes };
